import React from 'react';
import { useRef, FC, useEffect, useState } from 'react';

import { CanvasContext } from './components/useCanvas';
import useResponsiveSize from './components/useResponsiveSize';
import Wave from './components/Wave';

const Canvas: FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const { width } = useResponsiveSize();
  const [context, setContext] = useState<
    CanvasRenderingContext2D | undefined
  >();

  useEffect(() => {
    try {
      if (canvasRef && canvasRef?.current && canvasRef?.current?.getContext) {
        const ctx = canvasRef?.current?.getContext('2d');
        if (ctx) setContext(ctx);
      }
    }
    catch (e: any) {
      console.log(e)
    }
  }, []);

  return (
    <>
      <CanvasContext.Provider value={{ context }}>
        <canvas id="canvas" ref={canvasRef} width={width} height={220}></canvas>
        <Wave />
      </CanvasContext.Provider>
    </>
  );
};

export default Canvas;